import * as Localization from 'expo-localization';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { loadExpressionsAsync } from './i18n';

const CHAVE_CONFIGURACAO_IDIOMA = 'ConfiguracaoIdioma';

export enum ConfiguracoesIdiomasTipo {
  PadraoSistema = 'system',
  Portugues = 'pt',
  Ingles = 'en',
  Espanhol = 'es'
}

/**
 * Carrega as expressões no idioma configurado. Passando o `idioma`, ele é salvo
 * na configuração antes de ser aplicado; sem parâmetro, aplica o que já está salvo.
 */
export async function aplicarIdiomaAsync(idioma?: ConfiguracoesIdiomasTipo) {
  if (idioma) {
    await salvarConfiguracaoIdiomaAsync(idioma);
  }

  const idiomaAtual = obterIdiomaAtual(
    idioma ?? (await carregarConfiguracaoIdiomaAsync())
  );

  await loadExpressionsAsync(idiomaAtual);
}

export const carregarConfiguracaoIdiomaAsync = async () => {
  const idiomaJson = await AsyncStorage.getItem(CHAVE_CONFIGURACAO_IDIOMA);

  const idioma = idiomaJson
    ? (JSON.parse(idiomaJson) as ConfiguracoesIdiomasTipo)
    : ConfiguracoesIdiomasTipo.PadraoSistema;

  return idioma;
};

function obterIdiomaAtual(
  configuracoesIdiomas: ConfiguracoesIdiomasTipo
): string {
  return configuracoesIdiomas === ConfiguracoesIdiomasTipo.PadraoSistema
    ? obterIdiomaSistema()
    : configuracoesIdiomas;
}

// O expo-localization muda a forma de ler o idioma do sistema entre versões do SDK
// (era Localization.locale, virou getLocales()). Centralizamos aqui para que a próxima
// atualização seja uma edição em um único lugar. Tem suporte a web, então serve os dois.
function obterIdiomaSistema(): string {
  return Localization.getLocales()[0].languageTag;
}

const salvarConfiguracaoIdiomaAsync = async (
  idioma: ConfiguracoesIdiomasTipo
) => {
  await AsyncStorage.setItem(CHAVE_CONFIGURACAO_IDIOMA, JSON.stringify(idioma));
};
